module.exports = __webpack_public_path__ + "img/68.c90d52e.png";